/* Hearity Zubehoer-Finder. Vanilla JS, keine Bibliotheken.
   UI: Filterzeile mit Marke-Dropdown, Modell-Dropdown und Freitextsuche.
   Daten: assets/hy-finder-data.json (vorberechnet, Bauform-Regel bereits im Export angewendet).
   Events fuer Analytics: hy-finder:marke, hy-finder:modell, hy-finder:nicht-dabei, hy-finder:produkt-klick.
   Stand: 30.07.2026 */
(function () {
  'use strict';

  var GRUPPEN_REIHENFOLGE = ['filter', 'hoerer', 'pflege', 'fernbedienung', 'ladestation'];
  var ND = '__nicht_dabei__';

  /* Muss der Normalisierung im Export entsprechen:
     Kleinschreibung, ss statt Eszett, Akzente weg, Mehrfach-Leerzeichen zusammenziehen. */
  function norm(s) {
    s = (s || '').toLowerCase().replace(/ß/g, 'ss');
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) { /* alte Browser */ }
    return s.replace(/\s+/g, ' ').trim();
  }

  /* Suchbegriff: Ziffern entfernen, die an Buchstaben kleben (l90 -> l, 7ax -> ax),
     reine Zahl-Tokens behalten (312, 13, 10 sind Batteriegroessen).
     Aliasse fangen haeufige Schreibweisen ab (Audio -> Audeo). */
  var TOKEN_ALIAS = { 'audio': 'audeo', 'audeó': 'audeo' };
  function suchTokens(s) {
    return norm(s).split(' ').map(function (t) {
      t = /[a-z]/.test(t) ? t.replace(/\d+/g, '') : t;
      return TOKEN_ALIAS[t] || t;
    }).filter(function (t) { return t.length > 0; });
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function feuern(name, detail) {
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch (e) {}
  }

  function init(wrap) {
    var cfgEl = wrap.querySelector('script[data-hy-finder-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var t = cfg.texte || {};
    var markeSelect = wrap.querySelector('[data-hy-marke-select]');
    var modellSelect = wrap.querySelector('[data-hy-modell-select]');
    var suchInput = wrap.querySelector('[data-hy-such-input]');
    var bereich = wrap.querySelector('[data-hy-ergebnis-bereich]');
    var ergebnisWrap = wrap.querySelector('[data-hy-ergebnis]');
    var resetBtns = wrap.querySelectorAll('[data-hy-reset]');
    var meldung = wrap.querySelector('[data-hy-meldung]');

    var daten = null;
    var ladePromise = null;
    var optionZeilen = [];   // parallel zu den Modell-Optionen: {marke, zeile}

    /* ---------- Daten laden (lazy) ---------- */
    function lade() {
      if (ladePromise) return ladePromise;
      ladePromise = fetch(cfg.datenUrl, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (json) { daten = json; markenAktualisieren(); return json; })
        .catch(function (err) { daten = null; ladePromise = null; zeigeFehler(); throw err; });
      return ladePromise;
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { lade().catch(function () {}); io.disconnect(); }
        });
      }, { rootMargin: '200px' });
      io.observe(wrap);
    }

    /* ---------- Hilfen ---------- */
    function markenAktualisieren() {
      if (!daten || !daten.marken) return;
      var gewaehlt = markeSelect.value;
      var platzhalter = markeSelect.options[0];
      markeSelect.innerHTML = '';
      markeSelect.appendChild(platzhalter);
      daten.marken.forEach(function (m) {
        var o = document.createElement('option');
        o.value = m[0]; o.textContent = m[0];
        markeSelect.appendChild(o);
      });
      if (gewaehlt) markeSelect.value = gewaehlt;
    }

    function markenModelle(name) {
      if (!daten) return [];
      for (var i = 0; i < daten.marken.length; i++) {
        if (daten.marken[i][0] === name) return daten.marken[i][1];
      }
      return [];
    }

    function suchtext(marke, zeile) {
      var extra = (zeile.length > 2 && typeof zeile[2] === 'string') ? zeile[2] : '';
      return norm(marke + ' ' + zeile[1]) + ' ' + extra;
    }

    function passt(tokens, marke, zeile) {
      if (!tokens.length) return true;
      var s = suchtext(marke, zeile);
      for (var i = 0; i < tokens.length; i++) {
        if (s.indexOf(tokens[i]) === -1) return false;
      }
      return true;
    }

    /* ---------- Modell-Dropdown fuellen ---------- */
    function fuelleModelle() {
      var marke = markeSelect.value;
      var tokens = suchTokens(suchInput.value);
      optionZeilen = [];
      modellSelect.innerHTML = '';
      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = t.platzhalterModell;
      modellSelect.appendChild(ph);

      if (!daten) { modellSelect.disabled = true; return; }

      var quellen = [];
      if (marke) {
        markenModelle(marke).forEach(function (z) { quellen.push({ marke: marke, zeile: z }); });
      } else if (tokens.length) {
        /* Freitext ohne Marke: ueber alle Marken suchen */
        daten.marken.forEach(function (m) {
          m[1].forEach(function (z) { quellen.push({ marke: m[0], zeile: z }); });
        });
      }

      var treffer = 0;
      quellen.forEach(function (q) {
        if (!passt(tokens, q.marke, q.zeile)) return;
        var o = document.createElement('option');
        o.value = String(optionZeilen.length);
        o.textContent = marke ? q.zeile[1] : q.marke + ' – ' + q.zeile[1];
        modellSelect.appendChild(o);
        optionZeilen.push(q);
        treffer++;
      });

      /* "Mein Modell ist nicht dabei" immer als letzter Eintrag */
      if (marke || tokens.length) {
        var nd = document.createElement('option');
        nd.value = ND;
        nd.textContent = t.nichtDabei;
        modellSelect.appendChild(nd);
      }

      modellSelect.disabled = !(marke || tokens.length);
      if (treffer > 0) {
        ph.textContent = t.platzhalterModell + ' (' + treffer + ')';
      }
    }

    /* ---------- Kontakt (WhatsApp mit vorbefuelltem Text, Kontaktformular) ---------- */
    function kontaktButtons(marke, tipp) {
      var box = el('div', 'hy-finder__kontakt');
      var betreff = 'Zubehör-Anfrage: ' + (marke ? marke + ' ' : '') + (tipp || '');
      var wa = el('a', 'hy-finder__btn hy-finder__btn--voll', 'Per WhatsApp fragen');
      var waUrl = cfg.kontakt.whatsapp || '';
      if (waUrl.indexOf('wa.me/message/') === -1) {
        waUrl += (waUrl.indexOf('?') > -1 ? '&' : '?') + 'text=' + encodeURIComponent(betreff.trim());
      }
      wa.href = waUrl;
      wa.target = '_blank';
      wa.rel = 'noopener';
      var form = el('a', 'hy-finder__btn hy-finder__btn--leicht', 'Zum Kontaktformular');
      form.href = cfg.kontakt.formular;
      box.appendChild(wa); box.appendChild(form);
      return box;
    }

    /* ---------- Anzeige ---------- */
    function zeigeFehler() {
      meldung.hidden = true;
      bereich.hidden = false;
      ergebnisWrap.innerHTML = '';
      ergebnisWrap.appendChild(el('p', 'hy-finder__fehler', t.fehler));
      ergebnisWrap.appendChild(kontaktButtons(markeSelect.value, suchInput.value));
    }

    function zeigeNichtDabei() {
      feuern('hy-finder:nicht-dabei', { marke: markeSelect.value, eingabe: suchInput.value });
      bereich.hidden = false;
      ergebnisWrap.innerHTML = '';
      ergebnisWrap.appendChild(el('h3', 'hy-finder__h3', t.nichtDabei));
      ergebnisWrap.appendChild(el('p', 'hy-finder__text', t.nichtDabeiText));
      ergebnisWrap.appendChild(kontaktButtons(markeSelect.value, suchInput.value));
      urlSetzen(null);
    }

    function produktKarte(idx, marke, handle) {
      var p = daten.produkte[idx];
      var a = el('a', 'hy-finder__karte');
      a.href = '/products/' + p.h;
      a.addEventListener('click', function () {
        feuern('hy-finder:produkt-klick', { marke: marke, modell: handle, produkt: p.h });
      });
      var media = el('span', 'hy-finder__karte-media');
      var img = document.createElement('img');
      img.src = daten.cdn + p.b + (p.b.indexOf('?') > -1 ? '&' : '?') + 'width=400';
      img.alt = p.t;
      img.loading = 'lazy';
      img.width = 200; img.height = 200;
      media.appendChild(img);
      a.appendChild(media);
      a.appendChild(el('span', 'hy-finder__karte-titel', p.t));
      a.appendChild(el('span', 'hy-finder__karte-preis', p.p.toFixed(2).replace('.', ',') + ' €'));
      return a;
    }

    function zeigeErgebnis(marke, zeile) {
      var handle = zeile[0];
      feuern('hy-finder:modell', { marke: marke, modell: handle });
      meldung.hidden = true;
      bereich.hidden = false;
      ergebnisWrap.innerHTML = '';

      var kopf = el('p', 'hy-finder__bestaetigung');
      kopf.appendChild(document.createTextNode(t.bestaetigung + ' '));
      kopf.appendChild(el('strong', null, marke + ' ' + zeile[1]));
      ergebnisWrap.appendChild(kopf);

      var eigene = (zeile.length > 3 && Array.isArray(zeile[3])) ? zeile[3]
                 : (zeile.length > 2 && Array.isArray(zeile[2])) ? zeile[2] : [];
      var universal = daten.universal || [];

      GRUPPEN_REIHENFOLGE.forEach(function (g) {
        var idsEigene = eigene.filter(function (i) { return daten.produkte[i].g === g && universal.indexOf(i) === -1; });
        var idsUni = universal.filter(function (i) { return daten.produkte[i].g === g; });
        if (idsEigene.length === 0 && idsUni.length === 0) return; /* leere Gruppe ausblenden */
        var block = el('div', 'hy-finder__gruppe');
        block.appendChild(el('h3', 'hy-finder__h3', daten.gruppen[g] || g));
        var grid = el('div', 'hy-finder__grid');
        idsEigene.forEach(function (i) { grid.appendChild(produktKarte(i, marke, handle)); });
        idsUni.forEach(function (i) { grid.appendChild(produktKarte(i, marke, handle)); });
        block.appendChild(grid);
        ergebnisWrap.appendChild(block);
      });

      ergebnisWrap.appendChild(el('p', 'hy-finder__text hy-finder__nachsatz', 'Nicht sicher, ob das passt? Schreib uns kurz, wir prüfen es persönlich.'));
      ergebnisWrap.appendChild(kontaktButtons(marke, zeile[1]));
      ergebnisWrap.scrollTop = 0;
      urlSetzen({ marke: marke, modell: handle });
    }

    /* ---------- URL-Parameter (Deep-Links) ---------- */
    function urlSetzen(auswahl) {
      try {
        var u = new URL(window.location.href);
        if (auswahl && auswahl.marke) { u.searchParams.set('marke', auswahl.marke); } else { u.searchParams.delete('marke'); }
        if (auswahl && auswahl.modell) { u.searchParams.set('modell', auswahl.modell); } else { u.searchParams.delete('modell'); }
        history.replaceState(null, '', u.toString());
      } catch (e) {}
    }

    /* ---------- Verdrahtung ---------- */
    markeSelect.addEventListener('change', function () {
      var marke = markeSelect.value;
      if (marke) feuern('hy-finder:marke', { marke: marke });
      bereich.hidden = true;
      fuelleModelle();
      if (!daten) { lade().then(fuelleModelle).catch(function () {}); }
      urlSetzen(marke ? { marke: marke } : null);
    });

    suchInput.addEventListener('input', function () {
      bereich.hidden = true;
      if (!daten) { lade().then(fuelleModelle).catch(function () {}); return; }
      fuelleModelle();
    });

    modellSelect.addEventListener('change', function () {
      var wert = modellSelect.value;
      if (wert === '') { bereich.hidden = true; return; }
      if (wert === ND) { zeigeNichtDabei(); return; }
      var q = optionZeilen[parseInt(wert, 10)];
      if (!q) return;
      if (!markeSelect.value) { markeSelect.value = q.marke; }
      zeigeErgebnis(q.marke, q.zeile);
    });

    function neueSuche() {
      markeSelect.value = '';
      suchInput.value = '';
      fuelleModelle();
      bereich.hidden = true;
      ergebnisWrap.innerHTML = '';
      urlSetzen(null);
      markeSelect.focus();
    }
    resetBtns.forEach(function (btn) { btn.addEventListener('click', neueSuche); });

    /* Deep-Link: ?marke=…&modell=… */
    try {
      var u = new URL(window.location.href);
      var pm = u.searchParams.get('marke');
      var pmod = u.searchParams.get('modell');
      if (pm) {
        lade().then(function () {
          var vorhanden = daten.marken.some(function (m) { return m[0] === pm; });
          if (!vorhanden) return;
          markeSelect.value = pm;
          fuelleModelle();
          if (pmod) {
            for (var i = 0; i < optionZeilen.length; i++) {
              if (optionZeilen[i].zeile[0] === pmod) {
                modellSelect.value = String(i);
                zeigeErgebnis(optionZeilen[i].marke, optionZeilen[i].zeile);
                break;
              }
            }
          }
        }).catch(function () {});
      }
    } catch (e) {}
  }

  function start() {
    document.querySelectorAll('[data-hy-finder]').forEach(init);
  }
  if (document.readyState !== 'loading') { start(); }
  else { document.addEventListener('DOMContentLoaded', start); }
})();
